export default "__VITE_ASSET__DE2Yru6Z__"